module.exports = __webpack_public_path__ + "d6d8e49568e56e125484ba2cab311b87.png";